// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r5r3","option":"styles_option__s8R_3","active":"styles_active__1hxF9"};